import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { HeadphonesOutlined } from '@landr/maestro';

export interface CreatorLogoProps {
    link?: string;
}

const CreatorLogo: React.FC<CreatorLogoProps> = ({ link = '' }) => {
    const isLinked: boolean = useMemo(
        () => (link?.length ? true : false),
        [link],
    );

    return isLinked ? (
        <Link
            to={link}
            onClick={() => {
                window.scrollTo(0, 0);
            }}
            style={{ cursor: 'pointer' }}
        >
            <HeadphonesOutlined size="xl" color="icon.primary" />
        </Link>
    ) : (
        <HeadphonesOutlined
            data-testid="CreatorLogo-unlinked"
            size="xl"
            color="icon.primary"
            style={{ cursor: 'default' }}
        />
    );
};

export default CreatorLogo;
